import React from 'react';
import Axios from 'axios';

import { useActions } from '@digital/ui/lib/store';
import { Loading } from '@digital/ui';

interface LoginProps {
    onAuthenticate: (isAuthenticated: boolean) => void;
}

const ExternalRedirect = ({ onAuthenticate }: LoginProps) => {
    const loadPermissions = useActions(state => state.permission.loadPermissions);

    const params = new URLSearchParams(location.search);

    const token = params.get('token');
    const redirectUrl = params.get('redirectUrl');
    const originId = params.get('originId');
    const originUrl = params.get('originUrl');

    let urlBase = window.location.origin + `/api/account/authenticateByToken`;

    Axios.get(urlBase, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    }).then((response: any) => {

        const data = response.data;

        if (data && data.valid) {
            localStorage.setItem('isAuthenticated', 'true');
            localStorage.setItem('isMRN', data.isMRN);
            localStorage.setItem('codigoUsuario', data.codigoUsuario);
            localStorage.setItem('idtoken', data.access_token);
            localStorage.setItem('expiration', data.expires_in);
            localStorage.setItem('url', data.url);
            localStorage.setItem('originRedirect', originUrl || '');
            onAuthenticate(true);
            if (data.isFirstAccess == true) {
                loadPermissions(['dfc2fd92-3024-4641-9219-ea357a4eeeb3']);
                window.location.href = '/primeiroAcesso';
            } else {
                loadPermissions(data.permissoes);

                window.history.replaceState(null, '', window.location.origin + (redirectUrl || originUrl || '/login'))
                window.location.href = window.location.origin + (redirectUrl || originUrl || '/login');
            }
        } else {
            var h = '';
            if (data.notifications) {
                var err = data.notifications.map((n: any) => n.message).join('|')
                h = err
                    ? `?systemId=${originId}&errors=${JSON.stringify(err)}`
                    : '';
            }
            window.location.href = originUrl + h || '/login';
        }
    });

    return <div className='divFullScreen'>
        <Loading loading={true}></Loading>
    </div>;
};

export default ExternalRedirect;